import React from 'react';
import utils from '../../lib/utils';
import './index.scss';

export default function Footnote() {
  const features = utils.getCookie('features');
  return (
    features && !features.includes('CONTACT_INFO_HIDDEN') ? (
      <p className="footnote">
        Reach us at support@truelark.com or call 1-408-582-7010
      </p>
    ) : (
      <></>
    )
  );
}
